var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7074 5.03901V8.06352H13.7145V13.039H7.71454V5.03901H10.7074Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 3L15.75 6V14C15.75 14.5531 15.3031 15 14.75 15H6.75C6.19688 15 5.75 14.5531 5.75 14V4C5.75 3.44688 6.19688 3 6.75 3H12.75ZM7.21454 4.04255C6.9384 4.04255 6.71454 4.26641 6.71454 4.54255V13.5461C6.71454 13.8222 6.9384 14.0461 7.21454 14.0461H14.2145C14.4907 14.0461 14.7145 13.8222 14.7145 13.5461V7.54255C14.7145 7.26641 14.4907 7.04255 14.2145 7.04255H12.2145C11.9384 7.04255 11.7145 6.8187 11.7145 6.54255V4.54255C11.7145 4.26641 11.4907 4.04255 11.2145 4.04255H7.21454Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1L9.75 2H2.75V12H4.75V13H2.75C2.19687 13 1.75 12.5531 1.75 12V2C1.75 1.44687 2.19687 1 2.75 1H8.75Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverCopyIcon);
export default __webpack_public_path__ + "static/media/hoverCopyIcon.675178fe4a6a66bd630491a50b295872.svg";
export { ForwardRef as ReactComponent };